import React from "react";

export default ({message, children}) => {
    return (
        <div style={{ color: "red" }} tabIndex="0">
            {message || children}
        </div>
    );
};
